var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.49121 7.51754L6.99998 11.0263L10.5088 7.51754L9.75437 6.76316L7.5263 8.99123V4.00877H6.47366V8.99123L4.24559 6.76316L3.49121 7.51754Z",
    fill: "#FF9900"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75439 13.7632C4.51462 14.1608 5.33918 14.4064 6.22807 14.5L6.22805 13.4474C4.73097 13.2251 3.49413 12.5526 2.51752 11.4298C1.54092 10.307 1.05261 8.99708 1.05261 7.5C1.05261 6.00292 1.54385 4.69298 2.52631 3.57018C3.50876 2.44737 4.74854 1.77485 6.24561 1.55263L6.24561 0.5C4.45614 0.687135 2.96784 1.44737 1.7807 2.7807C0.593567 4.11403 0 5.68713 0 7.5C0 8.40058 0.157905 9.25438 0.473694 10.0614C0.789484 10.8684 1.22515 11.5877 1.7807 12.2193C2.33626 12.8509 2.99415 13.3655 3.75439 13.7632Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77191 13.4474V14.5C8.45027 14.4415 9.10232 14.2778 9.72805 14.0088C10.3538 13.7398 10.9357 13.4006 11.4737 12.9912L10.7018 12.2193C10.2807 12.5585 9.82162 12.8304 9.32454 13.0351C8.82747 13.2398 8.30992 13.3772 7.77191 13.4474Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31577 2C9.807 2.21637 10.2749 2.48246 10.7193 2.79825L11.4737 2.02632C10.924 1.61696 10.3392 1.2807 9.71928 1.01754C9.09939 0.754386 8.45027 0.581871 7.77191 0.5V1.55263C8.30992 1.6345 8.82454 1.78363 9.31577 2Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7193 11.1667L12.4737 11.9035C12.8947 11.3772 13.2339 10.8012 13.4912 10.1754C13.7485 9.54971 13.9181 8.89766 14 8.2193H12.9298C12.8596 8.75731 12.7251 9.27485 12.5263 9.77193C12.3275 10.269 12.0585 10.7339 11.7193 11.1667Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5263 5.2193C12.7251 5.72222 12.8596 6.24269 12.9298 6.7807H14C13.9298 6.11403 13.7719 5.47076 13.5263 4.85088C13.2807 4.23099 12.9532 3.65205 12.5439 3.11403L11.7193 3.83333C12.0585 4.25439 12.3275 4.71637 12.5263 5.2193Z",
    fill: "#FF9900"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipProgress);
export default __webpack_public_path__ + "static/media/chip-progress.97a716fc0f6c27869655b3979930b2b6.svg";
export { ForwardRef as ReactComponent };